import React, {Component} from 'react';
import Lightbox from 'react-image-lightbox';

class DeliveryPhotos extends Component {

    constructor(props) {
        super(props);

        this.state = {
            photoIndex: 0,
            isOpen: false
        };

        this.images = {
            thumbs: [],
            full: [],
        };
        for (var value of this.props.photos) {
            this.images.thumbs.push(value.thumb);
            this.images.full.push(value.full);
        }
    }

    render() {

        //const thumbs = this.images.thumbs;
        const images = this.images.full;
        const {
            photoIndex,
            isOpen,
        } = this.state;

        const thumbnails = this.images.thumbs.map((url, index) => {return <div key={"photo_" + index} onClick={() => this.setState({ isOpen: true, photoIndex: index })}><img src={url} alt="Proof of delivery" className="img-fluid" /></div>})

        return (
            <section className="images">
                <div className="thumbnails">{thumbnails}</div>

                {isOpen &&
                <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}

                    onCloseRequest={() => this.setState({ isOpen: false })}
                    onMovePrevRequest={() => this.setState({
                        photoIndex: (photoIndex + images.length - 1) % images.length,
                    })}
                    onMoveNextRequest={() => this.setState({
                        photoIndex: (photoIndex + 1) % images.length,
                    })}
                    imagePadding="0"
                />
                }
            </section>
        );
    }
}

export default DeliveryPhotos;



// WEBPACK FOOTER //
// ./src/components/DeliveryPhotos.js